import Splide from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', () => {
  const heroSplideEl = document.querySelector('.hero__splide');

  if (!heroSplideEl) return;

  // Un seul slide : pas de loop (sinon Splide clone le slide et le rend
  // draggable), pas de dots, pas d'autoplay.
  const hasMultipleSlides = heroSplideEl.querySelectorAll('.splide__slide').length > 1;

  const heroSplide = new Splide(heroSplideEl, {
    type: hasMultipleSlides ? 'loop' : 'slide',
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: hasMultipleSlides,
    autoplay: hasMultipleSlides,
    drag: hasMultipleSlides,
    interval: 6000,
    pauseOnHover: true,
    speed: 800,
  });

  heroSplide.mount();
});